// Field → lead-attribute mapping targets. Mirrors the backend WebFormMappingEnum.

export const MAPPING_LABELS = {
  none: 'Kein Mapping',
  'person.full_name': 'Person · Voller Name (Auto-Split)',
  'person.salutation': 'Person · Anrede',
  'person.first_name': 'Person · Vorname',
  'person.last_name': 'Person · Nachname',
  'person.position': 'Person · Position',
  'person.url': 'Person · Webseite',
  'person.note': 'Person · Notiz',
  'person.email': 'Person · E-Mail',
  'person.phone': 'Person · Telefon',
  'person.industry': 'Person · Branche',
  'company.name': 'Firma · Name',
  'company.name_short': 'Firma · Kurzname',
  'company.url': 'Firma · Webseite',
  'company.note': 'Firma · Notiz',
  'company.employee_count': 'Firma · Mitarbeiterzahl',
  'company.email': 'Firma · E-Mail',
  'company.phone': 'Firma · Telefon',
  'company.industry': 'Firma · Branche',
  'address.street': 'Adresse · Straße',
  'address.house_number': 'Adresse · Hausnummer',
  'address.zip_code': 'Adresse · PLZ',
  'address.city': 'Adresse · Stadt',
  'address.country': 'Adresse · Land',
};

const PERSON = [
  'person.full_name', 'person.salutation', 'person.first_name', 'person.last_name',
  'person.position', 'person.url', 'person.note', 'person.email', 'person.phone',
];
const COMPANY = [
  'company.name', 'company.name_short', 'company.url', 'company.note',
  'company.employee_count', 'company.email', 'company.phone',
];
const ADDRESS = [
  'address.street', 'address.house_number', 'address.zip_code', 'address.city', 'address.country',
];

export function mappingOptionsFor(leadType) {
  let keys = ['none'];
  if (leadType === 'person') keys = keys.concat(PERSON, ADDRESS);
  else if (leadType === 'company') keys = keys.concat(COMPANY, ADDRESS);
  else keys = keys.concat(PERSON, COMPANY, ADDRESS);
  return keys.map((k) => ({ value: k, label: MAPPING_LABELS[k] || k }));
}

// Required lead attribute groups (at least one of each group must be mapped).
export function requiredMappingGroups(leadType) {
  if (leadType === 'person') return [['person.last_name', 'person.full_name']];
  if (leadType === 'company') return [['company.name']];
  return [['person.last_name', 'person.full_name'], ['company.name']];
}

export const FIELD_TYPES = [
  { value: 'text', label: 'Text' },
  { value: 'email', label: 'E-Mail' },
  { value: 'tel', label: 'Telefon' },
  { value: 'textarea', label: 'Textbereich' },
  { value: 'number', label: 'Zahl' },
  { value: 'date', label: 'Datum' },
  { value: 'select', label: 'Auswahl' },
  { value: 'checkbox', label: 'Checkbox' },
  { value: 'radio', label: 'Radio' },
];

export function slugify(label) {
  return (label || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 64);
}
